import { render, staticRenderFns } from "./DteStandardRecipientSection.vue?vue&type=template&id=67c5706a"
import script from "./DteStandardRecipientSection.vue?vue&type=script&lang=js"
export * from "./DteStandardRecipientSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports